const baseInput = method => ({
  default: method.default,
  id: method.cachedId,
  label: method.label,
  selected: method.selected,
});

const mapCallbackShippingMethodsInput = methods => methods.map(baseInput);

const mapProfileShippingMethodsInput = methods =>
  methods.map(method => ({
    ...baseInput(method),
    shippingMethodType: method.shippingMethodType,
  }));

export { mapCallbackShippingMethodsInput, mapProfileShippingMethodsInput };
